import { useTranslation } from "react-i18next";
import { Button, Space, message, Tag, Image } from "antd";
import { EditOutlined, DeleteOutlined, PushpinOutlined } from "@ant-design/icons";
import SearchDataIndex from "../../../context/share/SearchDataIndex";
import requets from "../../../api";
import { useAppAuth } from "../../../context/use-app-auth";

export default function Column(getZones, onEdit) {
  const auth = useAppAuth();
  const req = requets(auth.user?.access_token);

  const getDataIndex = SearchDataIndex();
  const { t } = useTranslation("global");
  const [messageSend, contextHolder] = message.useMessage();

  const FALLBACK_IMAGE = "https://b.tile.openstreetmap.org/14/4787/7688.png";

  const renderThumbnail = (url, altText) => {
    const imageSrc = url || FALLBACK_IMAGE;

    return (
      <Image
        src={imageSrc}
        alt={altText}
        width={80}
        style={{ objectFit: "cover", borderRadius: 8 }}
        preview
      />
    );
  };

  const handleEditEvent = (key) => {
    onEdit(key);
  };

  const handleDeleteEvent = (key) => {
    req.delete(`/locations/${key}`).then((response) => {
      if (response.status === 200) {
        getZones();

        messageSend.open({
          type: "success",
          content: t("zones.successDeleted"),
          duration: 10,
        });
      }
    });
  };

  const column = [
    // { title: t("zones.tableColumn.id"), dataIndex: "value", key: "value" },
    // { title: t("zones.tableColumn.code"), dataIndex: "code", key: "code" },
    {
      //title: t("zones.tableColumn.zoneName"),
      title: t("zones.tableColumn.sellingLocation"),
      dataIndex: "name",
      key: "name",
      ...getDataIndex("name"),
    },
    {
      title: t("zones.tableColumn.description"),
      dataIndex: "description",
      key: "description",
    },

    {
      title: "Diagrama unifilar",
      dataIndex: "urlDiagramImage",
      key: "urlDiagramImage",
      render: (url) => renderThumbnail(url, "Diagrama unifilar"),
      width: 120,
    },
    {
      title: "Imagen tienda",
      dataIndex: "urlLocationImage",
      key: "urlLocationImage",
      render: (url) => renderThumbnail(url, "Imagen tienda"),
      width: 120,
    },
    // {
    //   title: t("device.tableColumn.control"),
    //   dataIndex: "uuid",
    //   key: "controls",
    //   render: (_, record) => (
    //     <Space>
    //       <Switch
    //         //defaultChecked={currentDevice?.mode === "MANUAL" ? true : false}
    //         //checked={currentDevice?.mode === "MANUAL" ? true : false}
    //         checkedChildren={t("lamp.manual")}
    //         unCheckedChildren={t("lamp.automatic")}
    //         onChange={(checked) => handleSwitchMode(checked, record)}
    //       />
    //       <Divider />
    //       <Switch
    //         checkedChildren="ON"
    //         unCheckedChildren="OFF"
    //         onChange={(checked) => onChange(checked, record)}
    //       />
    //       <div className="container__dimerization-slider">
    //         <Radio.Group
    //           buttonStyle="solid"
    //           onChange={(checked) => handlerDimerization(checked, record)}
    //         >
    //           <Radio.Button value="ALTO">{t("lamp.high")}</Radio.Button>
    //           <Radio.Button value="MEDIO">{t("lamp.half")}</Radio.Button>
    //           <Radio.Button value="INTERM">{t("lamp.middle")}</Radio.Button>
    //           <Radio.Button value="BAJA">{t("lamp.low")}</Radio.Button>
    //         </Radio.Group>
    //       </div>
    //     </Space>
    //   ),
    // },
    // {
    //   title: t("device.tableColumn.message"),
    //   dataIndex: "uuid",
    //   key: "message",
    //   render: (_, record) => (
    //     <Space>
    //       <div className="container__dimerization-slider">
    //         <Radio.Group
    //           defaultValue={record.message}
    //           buttonStyle="solid"
    //           onChange={(checked) => handlerMessage(checked, record)}
    //         >
    //           <Radio.Button value="T=1M">{t("lamp.tm1")}</Radio.Button>
    //           <Radio.Button value="T=3M">{t("lamp.tm3")}</Radio.Button>
    //           <Radio.Button value="T=5M">{t("lamp.tm5")}</Radio.Button>
    //           <Radio.Button value="T=15M">{t("lamp.tm15")}</Radio.Button>
    //         </Radio.Group>
    //       </div>
    //     </Space>
    //   ),
    // },
    // {
    //   title: t("zones.tableColumn.municipality"),
    //   dataIndex: "counties",
    //   key: "counties",
    //   render: (county) => county.label,
    // },
    // {
    //   title: t("zones.tableColumn.department"),
    //   dataIndex: "departments",
    //   key: "departments",
    //   render: (department) => department.label,
    // },
    {
      title: t("zones.tableColumn.location"),
      dataIndex: "coordenates",
      key: "coordenates",
      render: (coordenates) => {
        return (
          <Tag color="blue" icon={<PushpinOutlined />}  >
            <a href={`https://www.google.com/maps?q=${coordenates[0]},${coordenates[1]}`}
              target="_blank"
              rel="noopener noreferrer">
              {coordenates[0]}, {coordenates[1]}
            </a>

          </Tag>
        );
      }
    },
    {
      title: t("zones.tableColumn.creationDate"),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => new Date(date).toLocaleDateString("es-CO"),
    },
    {
      title: t("zones.tableColumn.option"),
      dataIndex: "uuid",
      key: "uuid",
      render: (_, record) => (
        <Space direction="vertical">
          <Space>
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => handleEditEvent(record.uuid)}
            >
              {t("zones.edit")}
            </Button>
            {contextHolder}
            <Button
              type="text"
              icon={<DeleteOutlined size={"large"} />}
              onClick={() => handleDeleteEvent(record.uuid)}
            >
              {" "}
              {t("zones.delete")}
            </Button>
          </Space>
        </Space>
      ),
      width: 200,
    },
  ];

  return column;
}
